// This file is automatically generated by Firebase Studio.
// Do not edit this file manually, as your changes will be overwritten.
//
// To edit your Firebase project's configuration, edit the 'firebaseProjectId' field
// in your project's 'app.json' file.
import { FirebaseOptions } from 'firebase/app';

const firebaseConfig: FirebaseOptions = {
  apiKey: "AIzaSyC-kULouxOiYsjxcZiXlNsvrvtjSQDgQYU",
  authDomain: "studio-5454502800-ff858.firebaseapp.com",
  projectId: "studio-5454502800-ff858",
  storageBucket: "studio-5454502800-ff858.appspot.com",
  messagingSenderId: "780756320456",
  appId: "1:780756320456:web:ba094c638b96734481e5fd",
  measurementId: "G-XX5WDLXMJ6"
};

export function getFirebaseConfig(): FirebaseOptions {
  if (!firebaseConfig.apiKey || firebaseConfig.apiKey === "YOUR_API_KEY") {
    throw new Error('No Firebase API Key provided');
  }
  return firebaseConfig;
}
